import React, { ReactElement } from 'react'
import { ScreenReaderOnly, TextBody } from '@ally/metronome-ui'

interface DashDashProps {
  assistiveText: string
  asSpan?: true
}

export const DashDash: React.FC<DashDashProps> = ({
  assistiveText,
  asSpan,
}): ReactElement => {
  return (
    <TextBody tag={asSpan ? 'span' : 'p'} size="md">
      <span aria-hidden="true">--</span>
      <ScreenReaderOnly>{assistiveText}</ScreenReaderOnly>
    </TextBody>
  )
}
